import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetEnergyQuery,
  usePublicGetEnergyQuery,
  useGetEnergyEntriesQuery,
  usePublicGetEnergyEntriesQuery,
  useGetEnergyEntriesDefaultsQuery,
  usePublicGetEnergyEntriesDefaultsQuery,
  useUpdateEnergiesMutation,
  useCreateEnergyEntryMutation,
  useUpdateEnergyEntryMutation,
  useDeleteEnergyEntryMutation
} from '../features/modules/energyApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting energy data based on the current route.
 */
export const useContextAwareGetEnergy = createContextAwareHook(
  useGetEnergyQuery,
  usePublicGetEnergyQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting energy entries based on the current route.
 */
export const useContextAwareGetEnergyEntries = createContextAwareHook(
  useGetEnergyEntriesQuery,
  usePublicGetEnergyEntriesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting energy entries defaults based on the current route.
 */
export const useContextAwareGetEnergyEntriesDefaults = createContextAwareHook(
  useGetEnergyEntriesDefaultsQuery,
  usePublicGetEnergyEntriesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateEnergiesMutation,
  useCreateEnergyEntryMutation,
  useUpdateEnergyEntryMutation,
  useDeleteEnergyEntryMutation
}; 